import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { AccountEntities } from "../AccountEntities";

interface ServiceSessionListPageProps extends NSARouterMakerResult, AccountRouterProps
{ }

export default function ServiceSessionListPage(props: ServiceSessionListPageProps) 
{
    return (
        <AccountLayout {...props}
            action={{
                title: 'Service Session List',
                description: 'Control and monitor your service sessions to ensure secure access to your service users.',
                menus: {}
            }}
            pages={{
                entity: AccountEntities.service_session(props),
                list: {
                    ui: {}
                }
            }}
        >
            <></>
        </AccountLayout>
    );
};